import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { useViagensListagem } from '../hooks/useViagensListagem';
import { useViagensNavegacao } from '../hooks/useViagensNavegacao';
import ViagensHeader from './ViagensHeader';
import ViagensTable from './ViagensTable';
import ViagensFilter from './ViagensFilter';

const ViagensCard = ({
  showActions = true,
  enableRowClick = true,
  showFilter = true,
  showHeader = true
}) => {
  // Hooks
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginationState,
    handleFilterApply,
    handleLimparFiltros,
    handleExcluir,
    handlePaginationChange,
    setPaginationState
  } = useViagensListagem();

  const { handleRowClick, handleAdicionar, handleEditar } = useViagensNavegacao();

  return (
    <Card>
      <CardBody>
        {showHeader && (
          <ViagensHeader totalRegistros={totalRegistros} onAdicionar={handleAdicionar} />
        )}

        {showFilter && (
          <ViagensFilter
            loading={filterLoading}
            onApply={handleFilterApply}
            onLimpar={handleLimparFiltros}
          />
        )}

        <ViagensTable
          data={data}
          loading={loading}
          onRowClick={enableRowClick ? handleRowClick : undefined}
          onEditar={showActions ? handleEditar : undefined}
          onExcluir={showActions ? handleExcluir : undefined}
          totalRegistros={totalRegistros}
          paginationState={paginationState}
          setPaginationState={handlePaginationChange}
        />
      </CardBody>
    </Card>
  );
};

export default ViagensCard;
